import { useParams, useSearchParams } from 'react-router-dom';
import { usePublicSessionDailyCall } from './hooks/usePublicSessionDailyCall';

const SessaoAcessoPublicoPage = () => {
	const { providerId } = useParams<{ providerId: string }>();
	const [searchParams] = useSearchParams();
	const userName = searchParams.get('userName')?.trim() || null;

	const { containerRef, isJoining, errorMessage } = usePublicSessionDailyCall(
		{
			providerId,
			userName,
		},
	);

	return (
		<div
			className="relative flex min-h-0 flex-1 flex-col"
			data-testid="public-session-access-page"
		>
			{isJoining && !errorMessage && (
				<p
					className="absolute inset-x-0 top-4 z-10 text-center text-sm font-medium text-zinc-400"
					data-testid="public-session-connecting"
				>
					Conectando à chamada…
				</p>
			)}

			{errorMessage && (
				<div
					className="absolute inset-0 z-40 flex flex-col items-center justify-center gap-4 bg-zinc-900 px-6 text-center text-zinc-300"
					data-testid="public-session-error"
				>
					<p className="max-w-md text-base font-medium leading-relaxed">
						{errorMessage}
					</p>
				</div>
			)}

			<div
				ref={containerRef}
				className="relative min-h-0 w-full flex-1"
				data-testid="public-session-call-stage"
				aria-hidden={!!errorMessage}
			/>
		</div>
	);
};

export { SessaoAcessoPublicoPage };
